import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const CommunityAudiencePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 1080px;
`;

export const HeaderSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0 ${Spacing.MD}px 0;
`;

export const titleStyle = css`
    margin-bottom: ${Spacing["2XS"]}px !important;
`;

export const subtitle = css`
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 18px;
    color: ${Colors.Gray.V300};
`;

export const iconStyle = {
    height: Spacing.LG,
    width: Spacing.LG,
    color: Colors.Black.V50,
};

export const demographicFlex = css`
    flex: 1 1 auto;
    width: 20%;
    border-radius: 6px;
    box-shadow: 0 ${Spacing["3XS"]}px ${Spacing["2XS"]}px rgba(0, 0, 0, 14%);

    > div {
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.MEDIUM};
        color: ${Colors.Black.V50};

        &:last-child {
            margin-left: ${Spacing.SM}px;
        }
    }
`;

export const cardData = css`
    font-size: ${FontSizeInPx.LARGE}px !important;
    font-weight: ${FontWeight.SEMI_BOLD};
    line-height: ${LineHeightInPx.LARGE}px;
    color: ${Colors.Black.V100};
`;

export const row = css`
    margin: ${Spacing.SM}px 0 ${Spacing.SM}px 0;

    > div {
        margin: ${Spacing.SM}px;

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }
    }
`;

export const ageBreakdown = css`
    margin: ${Spacing.SM}px 0 ${Spacing.SM}px 0;
`;

export const flexGrow = css`
    flex-grow: 1;
`;
export const osBreakdown = css`
    margin: ${Spacing.SM}px 0 ${Spacing.SM}px ${Spacing.LG}px;
`;

export const flexOneThird = css`
    flex-basis: ${100 / 3}%;
`;

export const halfScreenCardLeft = css`
    flex: 1 1 50%;
    max-width: 50%;
    height: 100%;
    margin: ${Spacing.SM}px ${Spacing.SM}px ${Spacing.SM}px 0;
`;

export const halfScreenCardRight = css`
    flex: 1 1 auto;
    max-width: 50%;
    height: 100%;
    margin: ${Spacing.SM}px 0 ${Spacing.SM}px ${Spacing.SM}px;
`;

export const TopLensesSection = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 210px;

    /* stylelint-disable-next-line selector-class-pattern -- Class Name is defined by AntD */
    > .top-lens-card_container:not(:last-child) {
        margin-right: 8px;
    }
`;

export const TopLensCardContainer = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: flex-end;

    width: 10%;
    height: calc(100% - 49px);

    border-radius: 6px;
`;

export const LensInfo = styled.div`
    position: absolute;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 90px;
    height: 68px;

    background: linear-gradient(180deg, rgba(0, 0, 0, 0%) 0%, rgba(123, 123, 123, 70%) 100%);
    border-radius: 6px;
`;

export const LensIcon = styled.img`
    cursor: pointer;

    width: 40px;
    height: 40px;

    background: ${Colors.Gray.V50};
    border: 1px solid ${Colors.Black.V100};
    border-radius: 60px;
`;

export const LensName = styled.span`
    width: 90px;

    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    line-height: ${LineHeightInPx.REGULAR}px;
`;

export const LensStat = styled.span`
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    line-height: 14px;
`;

export const NameAndValue = styled.div`
    display: flex;
    flex-direction: column;

    margin-top: 2px;
    padding-left: ${Spacing.XS}px;

    color: white;
    text-align: center;
`;

export const LensCardVideo = styled.video`
    border-radius: ${Spacing["1XS"]}px;
`;

export const LensCardImg = styled.img`
    width: 95px;
    min-height: 180px;
    border-radius: ${Spacing["1XS"]}px;
`;

export const LensCardEmptyPreview = styled.div`
    position: relative;

    width: 100%;
    height: 100%;

    background: #f5f5f5;
    border-radius: ${Spacing["1XS"]}px;
`;

export const filterDropdown = css`
    width: 300px;
    text-align: right;
`;

export const treeSelectStyle = css`
    .ant-popover-inner-content {
        width: 100%;
    }
`;
